import { Box } from '@wix/design-system';
import React, { FC, useMemo } from 'react';

import { classNames } from '../../../../util';
import { useCurrentPage } from '../../../common/hooks/useCurrentPage';
import { Page } from '../../../common/types';
import { renderModel } from '../../../util/renderModel';
import { BackButton } from '../BackButton';
import { HeaderActions } from '../HeaderActions';
import { HeaderTitle } from './HeaderTitle';
import s from './styles.scss';

export const Header: FC = () => {
  const currentPage = useCurrentPage();
  const isHomePage = useMemo(() => currentPage === Page.Home, [currentPage]);

  const className = classNames([
    s.header,
    renderModel.isInvokedFromHeader() && s.invokedFromHeader,
    isHomePage && s.homePage,
  ]);

  return (
    <Box direction="vertical" className={className}>
      <Box gap={1} className={s.headerContainer}>
        <BackButton />
        <Box flexGrow={1} direction="horizontal" overflow="hidden" margin="auto">
          <HeaderTitle />
        </Box>
        <HeaderActions />
      </Box>
    </Box>
  );
};
